import React from "react";
import BookCard from "@/components/site/BookCard";

export default function FeaturedBooks({ books }) {
  const featured = books.filter((b) => b.featured && !b.coming_soon);
  return (
    <section id="books" className="py-28 sm:py-36 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">The Collection</span>
          <h2 className="font-display text-4xl sm:text-5xl font-bold tracking-tight mt-4">Featured Books</h2>
          <p className="text-gray-600 mt-4 text-base leading-relaxed">
            Practical, research-based guides for students, graduates and professionals who want a lasting edge.
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-8 lg:gap-10">
          {featured.map((b, i) => (
            <div key={b.id} className="w-full lg:w-[calc(50%-1.25rem)]">
              <BookCard book={b} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
